import { Location, NavigateFunction, useNavigate } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';

import { WLIDS } from 'Constants';
import { Journey } from 'Global/Journey/Types/Journey';
import { appConfigStore } from 'Models/AppConfigStore';
import { store } from 'Models/Store';
import { hasOverlap } from 'Util/_HumanWritten/ArrayUtils';
import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';
import { StandbyValues } from 'Views/Components/_HumanWritten/CheckIn/FerryCheckIn/CheckInStandby/useStandbyForm';
import ErrorModal from '../Components/ErrorModal';
import { JoinStandbyModal } from '../Components/JoinStandbyModal';
import LoadingModal from '../Components/LoadingModal';
import StandbyOpenHoursChecker from '../Components/StandbyOpenHoursChecker';
import StandbyOpenHoursModal from '../Components/StandbyOpenHoursModal';

interface IsStandbyPopupRequiredArgs {
	journeys: Journey[];
	cargoTypeId: string;
	navigate: NavigateFunction;
	defaultValues?: StandbyValues;
}

export const isStandbyPopupRequired = ({
	journeys,
	cargoTypeId,
	navigate,
	defaultValues,
}: IsStandbyPopupRequiredArgs): boolean => {
	if (!appConfigStore.standbyEnabled) {
		return false;
	}

	if (store.isStaff) {
		return false;
	}

	const cargoCharacteristics = store.cargoTypeCharacteristicsMap[cargoTypeId];
	if (!cargoCharacteristics) {
		return false;
	}

	const ferryTripIds = journeys.map(x => x.tripId);

	const popupRequired = hasOverlap(appConfigStore.standbyCargoCharacteristicWatchlist, cargoCharacteristics);

	if (popupRequired) {
		newConfirmModal('', (onConfirm, onCancel) => (
			<StandbyOpenHoursChecker journeys={journeys}>
				{state => {
					if (state.type === 'data') {
						if (state.isOpen) {
							return (
								<JoinStandbyModal
									ferryTripIds={ferryTripIds}
									onClose={onConfirm}
									defaultValues={defaultValues}
									message={
										<FormattedMessage
											id={WLIDS.standby.preventNonAuthoriseCustomerMessage}
											defaultMessage="Please join the standby list to book for your vehicle."
										/>
									}
								/>
							);
						}
						return <StandbyOpenHoursModal onClose={onConfirm} />;
					}

					if (state.type === 'loading') {
						return <LoadingModal />;
					}

					return (
						<ErrorModal onClose={onConfirm}>Something went wrong, please try again another time</ErrorModal>
					);
				}}
			</StandbyOpenHoursChecker>
		))
			.then(() => {
				navigate('/booking-wizard/tickets');
			})
			.catch(() => {
				navigate('/booking-wizard/tickets');
			});

		return true;
	}

	return false;
};
